import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

const style = {
  wrapper: {
    // div  wrappers need a :before style to draw a separator between each menu item
    '&:before': {
      position: 'absolute',
      content: '" "',
      width: '100%',
      height: '1px',
      background: 'rgb(0,0,0)'
    }
  }
}

export function InsufficientPermissionTooltip({ children }: React.PropsWithChildren<{}>) {
  const { t } = useTranslation()

  return (
    <Tooltip title={<>{t('global.missing_permission')}</>} placement='right'>
      {/* needs a div in case the children have a disabled prop */}
      <Box sx={style.wrapper}>{children}</Box>
    </Tooltip>
  )
}
